<div class="chat-button-wrapper">
  <button
    type="button"
    class="open-chat-icon-wrapper"
    (click)="openMobileChat()"
    [attr.aria-label]="'CHAT.OPEN_CHAT' | translate"
    [attr.aria-describedby]="hasAnyNewMessages ? 'chat-new-msg' : null">
    <img class="chat-icon" src="assets/img/chat-icon.svg" alt="" />

    <span *ngIf="hasAnyNewMessages" class="new-messages-indicator" aria-hidden="true"> </span>

    <span *ngIf="hasAnyNewMessages" id="chat-new-msg" class="sr-only" aria-live="polite">
      {{ 'CHAT.YOU_HAVE_NEW_MESSAGES' | translate }}
    </span>
  </button>
</div>
